__turbopack_context__.v({
  "actions": "developersHero-module-scss-module__3TvyKa__actions",
  "card": "developersHero-module-scss-module__3TvyKa__card",
  "cardBadge": "developersHero-module-scss-module__3TvyKa__cardBadge",
  "cardBadgeAvailable": "developersHero-module-scss-module__3TvyKa__cardBadgeAvailable",
  "cardBadgeDot": "developersHero-module-scss-module__3TvyKa__cardBadgeDot",
  "cardImage": "developersHero-module-scss-module__3TvyKa__cardImage",
  "cardInfo": "developersHero-module-scss-module__3TvyKa__cardInfo",
  "cardNameLine": "developersHero-module-scss-module__3TvyKa__cardNameLine",
  "cardScrim": "developersHero-module-scss-module__3TvyKa__cardScrim",
  "collage": "developersHero-module-scss-module__3TvyKa__collage",
  "collageCard": "developersHero-module-scss-module__3TvyKa__collageCard",
  "column": "developersHero-module-scss-module__3TvyKa__column",
  "columnReverse": "developersHero-module-scss-module__3TvyKa__columnReverse",
  "content": "developersHero-module-scss-module__3TvyKa__content",
  "grid": "developersHero-module-scss-module__3TvyKa__grid",
  "hero": "developersHero-module-scss-module__3TvyKa__hero",
  "marqueeDown": "developersHero-module-scss-module__3TvyKa__marqueeDown",
  "marqueeUp": "developersHero-module-scss-module__3TvyKa__marqueeUp",
  "titleLine": "developersHero-module-scss-module__3TvyKa__titleLine",
  "track": "developersHero-module-scss-module__3TvyKa__track",
});
